import react, { useState, useEffect } from "react";

import React from "react";

function SearchBar({ data, handleSearchChange, dataType, status }) {
  const [searchInput, setSearchInput] = useState("");

  const clientsDataFiltered = () => {
    const dataFiltered = data
      ?.filter((val) => {
        if (
          [val.client.toLowerCase(), val.client_id + ""].some((r) =>
            r.includes(searchInput.toLowerCase())
          )
        ) {
          return val;
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const ordersDataFiltered = () => {
    const dataFiltered = data
      ?.filter((val) => {
      if (
        val.status.includes(status) &&
        (val.id + "" === searchInput || [val.group_name.toLowerCase()].some((r) =>
        r.includes(searchInput.toLowerCase())
        ))
      ) {
        return val;
      }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const bannerDataFiltered = () => {
    const dataFiltered = data
      ?.filter((val) => {
        if (
          [val.groupName.toLowerCase(), val.id + ""].some((r) =>
            r.includes(searchInput.toLowerCase())
          )
        ) {
          return val;
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const adsDataFiltered = () => { 
    const dataFiltered = data
      ?.filter((val) => {
        if (
          (val.isActive && status === "True" || !val.isActive && status === "False" || status === "") &&
          [val.id + "", val.title.toLowerCase()].some((r) =>
            r.includes(searchInput.toLowerCase())
          )
        ) {
          return val;
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const discountFiltered = () => {  
    const dataFiltered = data
      ?.filter((val) => {
        if (
          (val.id + "" === searchInput || searchInput === "") 
        ) {
          return val;
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const drinkCategoryFiltered = () => {
    const dataFiltered = data
      ?.filter((val) => {
        if (
          (status === "active" && val.isActive) ||
          (status === "inactive" && !val.isActive) ||
          status === ""
        ) {
          if (
            [val.name.toLowerCase(), val.description.toLowerCase(), val.id + ""].some((r) =>
              r.includes(searchInput.toLowerCase())
            )
          ) {
            return val;
          }
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const drinkFiltered = () => {
    const dataFiltered = data
      ?.filter((val) => {
        if (
          (status === "active" && val.isActive) ||
          (status === "inactive" && !val.isActive) ||
          status === ""
        ) {
          if (
            [val.name.toLowerCase(), val.description.toLowerCase(), val.drinkCategoryName.toLowerCase(), val.id + ""].some((r) =>
              r.includes(searchInput.toLowerCase())
            )
          ) {
            return val;
          }
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  const homeBannerFiltered = () => {
    const dataFiltered = data
      ?.filter((val) => {
        if (
          [val.data.toLowerCase(), val.id + ""].some((r) =>
            r.includes(searchInput.toLowerCase())
          )
        ) {
          return val;
        }
      })
      .reverse();
    handleSearchChange(dataFiltered);
  }

  useEffect(() => {
    if(dataType === "orders") {
        ordersDataFiltered();
    }
    if(dataType === "clients") {
        clientsDataFiltered();
    }
    if(dataType === "banner") {
      bannerDataFiltered();
    }
    if(dataType === "ad") {
      adsDataFiltered();
    }
    if(dataType === "discount") {
      discountFiltered();
    }
    if(dataType === "drinkCategory") {
      drinkCategoryFiltered();
    }
    if(dataType === "drink") {
      drinkFiltered();
    }
    if(dataType === "homeBanner") {
      homeBannerFiltered();
    }
  }, [searchInput, status]);


  return (
    <>
      <input
        type="text"
        placeholder="Search by name or ID"
        onChange={(e) => setSearchInput(e.target.value)}
        value={searchInput}
      />
    </>
  );
}

export default SearchBar;
